import React, { useState } from "react";
import { useHistory } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import {
    Container, Step, StepLabel, Stepper, Typography,
    TextField, Box, Button, CssBaseline, InputLabel, FormControl, Select, MenuItem, ListItemText, Checkbox, IconButton,
} from '@material-ui/core';
import { withRouter } from "react-router-dom";
import LoaderWithBackDrop from "../../components/LoaderWithBackDrop/LoaderWithBackDrop.comp";
import {Autocomplete, FormHelperText} from "@mui/material";
import {PROGRAM_TARGETS} from "../../utils/META/cat_108";
import Grid from "@material-ui/core/Grid";
import TermOfUse from "./TOU.comp";
import {registerUser, uploadEncryptedMedia, userExists} from "../../services/auth.service";
import {LOCAL_STORAGE_KEYS} from "../../utils/constants";
import {useAuth} from "../../context/auth";
import PoweredbyDQ from "../../assets/images/PoweredByDQ_Default.png";
import {REGIONS} from "../../utils/META/cat_101";
import {Field} from "formik";
import CloseIcon from "@material-ui/icons/Close";
import {uploadMedia} from "../../services/public.service";
import {DropzoneDialog} from "material-ui-dropzone";
import LoaderBackDropWithPercentage from "../../components/LoaderWithBackDrop/LoaderBackDropWithPercentage.comp";
import {PROMOTION_METHODS} from "../../utils/META/cat_123";
import PersonIcon from '@material-ui/icons/Person';
import BusinessIcon from '@material-ui/icons/Business';
import VerificationDialog from "./components/VerificationDialog.comp";
import {ORG_TYPES} from "../../utils/META/cat_102";


const useStyles = makeStyles((theme) => ({
    container: {
        padding: '30px 76px',
        maxWidth: '800px',
        margin: "auto",
        marginTop:'70px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
        [theme.breakpoints.down('sm')]: {
           paddingTop:'60px',
            padding: '30px 25px',
        },
    },

    title: {
        background: 'linear-gradient(to right, #6A8EC9 10%, #8C74A7 35%, #D44C71 59%, #C91C6E 100%)',
        color: 'transparent',
        backgroundClip: 'text',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        fontWeight: '500 !important',
        textAlign: 'center',
        fontSize: '40px !important',
        [theme.breakpoints.down('sm')]: {
            fontSize: "28px !important",
        },
    },
    question: {
        marginTop: theme.spacing(4),
        fontWeight: 'bold',
        color: '#000000',
        textAlign: 'center',
    },
    optional: {
        marginBottom: theme.spacing(2),
        color: '#000000',
        fontWeight: 'normal',
    },
    inputField: {
        marginBottom: theme.spacing(3),
        width: "65%",
        '& .MuiOutlinedInput-root': {
            borderRadius: '5px',
            '& fieldset': {
                border: '1px solid #ff5757',
            },
            '&:hover fieldset': {
                border: '1px solid #ff5757',
            },
            '&.Mui-focused fieldset': {
                border: '1px solid #ff5757',
                borderRadius: '5px',
            },
        },
        '& .MuiInputLabel-root': {
            color: '#929EA7',
        },
        '& .MuiInputLabel-root.Mui-focused': {
            color: '#ff5757',
        },
    },
    autoCompField:{
        width: "100%",
        '& .MuiOutlinedInput-root': {
            '& fieldset': {
                border: '1px solid #ff5757',
            },
            '&:hover fieldset': {
                border: '1px solid #ff5757',
            },
            '&.Mui-focused fieldset': {
                border: '1px solid #ff5757',
            },
        },
        '& .MuiInputLabel-root': {
            color: '#929EA7',
        },
        '& .MuiInputLabel-root.Mui-focused': {
            color: '#ff5757',
        },
    },
    formField:{
        '& .MuiOutlinedInput-root': {
            '& input': {
                padding: '12px 14px',
            },
            '& label': {
                color: '#929EA7',
            },
            '& label.Mui-focused': {
                color: '#ff5757',
            },
            '& fieldset': {
                border: '1px solid #ff5757',
            },
            '&:hover fieldset': {
                border: '1px solid #ff5757',
            },
            '&.Mui-focused fieldset': {
                border: '1px solid #ff5757',
                padding:'13px 14px !important',
            },
        },
    },
    nextButton: {
        width: '30%',
        fontWeight: 'bold',
        fontSize: '18px',
        borderRadius: '20px',
        backgroundColor: '#fe696e',
        color: '#ffffff !important',
        '&:hover': {
            backgroundColor: '#fe696e !important',
            color:'#ffffff !important'
        },
    },
    backButton: {
        width: '30%',
        fontWeight: 'bold',
        fontSize: '18px',
        borderRadius: '20px',
        backgroundColor: '#0097b2',
        color: '#ffffff !important',
        '&:hover': {
            backgroundColor: '#0097b2 !important',
            color:'#ffffff !important'
        },
    },
    stepper: {
        backgroundColor: 'transparent',
        width: '650px',
        '& .MuiStepIcon-root': {
            color: '#ccc',
        },
        '& .MuiStepIcon-root.Mui-active': {
            color: '#0097b2',
        },
        '& .MuiStepIcon-root.Mui-completed': {
            color: '#0097b2',
        },
        '& .MuiStepConnector-root': {
            position: 'absolute',
            width: '63px',
            top: '10px',
            left: '-31px',
            zIndex:'-1',
        },
        '& .MuiStepConnector-line': {
            borderColor: '#0097b2',
            borderTopWidth: 3,
        },
        [theme.breakpoints.down('sm')]: {
            width: '430px',
            '& .MuiStepConnector-root': {
                width: '43px',
                left: '-21px',
            },
        },
    },
    stepIcon: {
        color: '#ccc',
        fontSize: '1.5rem',
        '&.MuiStepIcon-active': {
            color: '#0097b2',
        },
        '&.MuiStepIcon-completed': {
            color: '#0097b2',
        },
    },
    optionButton: {
        textTransform:'none',
        margin: theme.spacing(2),
        padding: theme.spacing(2, 6),
        fontSize: '22px',
        fontWeight: 'bold',
        height:'150px',
        lineHeight:'1.2',
        marginTop:'30px',
        borderRadius: '30px',
        border: `1px solid #ff5757`,
        color: '#000000',
        '&:hover': {
            backgroundColor: '#fe696e',
            color: '#fff',
        },
        [theme.breakpoints.down('sm')]: {
            padding: '16px 25px',
        },
    },
    selectedOption: {
        backgroundColor: '#fe696e',
        color: '#fff',
    },
    textAreaField: {
        marginBottom: '20px',
        '& .MuiOutlinedInput-root': {
            borderRadius: '5px',
            '& fieldset': {
                borderColor: '#ff5757',
            },
            '&:hover fieldset': {
                borderColor: '#ff5757',
            },
            '&.Mui-focused fieldset': {
                borderColor: '#ff5757',
            },
        },
        '& .MuiInputLabel-root': {
            color: '#ff5757',
        },
        '& .MuiInputLabel-root.Mui-focused': {
            color: '#ff5757',
        },
    },
    dropdownField: {
        width: '100%',
        marginTop: '10px',
        marginBottom: '20px',
    },

    logoContainer: {
        position: 'absolute',
        top: '16px',
        right: '2%',
        zIndex: 3,
        [theme.breakpoints.down('sm')]: {
            top: '10px',
            right: '10px',
        },
    },

    logo: {
        height: 80,
        cursor: 'pointer',
        [theme.breakpoints.down('xs')]: {
            height: '60px',
        },
    },
    subText:{
        margin:'20px 10px',
        width: '970px',
        textAlign:'center',
        fontSize:'23px',
        [theme.breakpoints.down('xs')]: {
            width: '370px',
        },
}

}));

const steps = [
    "Step 1",
    "Step 2",
    "Step 3",
    "Step 4",
    "Step 5",
    "Step 6",
    "Step 7",
];


function UploadFileDialogue(props) {

    const { openDialogue, dialogueCloseHandler, successCB } = props;

    const [uploading, setUploading] = useState(false);
    const [uploadProgress, setUploadProgress] = useState(0);

    async function FileDialogueHandleSave(files) {
        setUploading(true);
        // const formData = new FormData();
        // formData.append('media', files[0]);
        const file = files[0];
        try {
            const result = await uploadEncryptedMedia(file, progressEvent => {
                const uploadPercentage = Math.floor((progressEvent.loaded / progressEvent.total) * 99);
                setUploadProgress(uploadPercentage);
            })
            if(result.data) {
                // const {media_path} = result.data;
                setUploadProgress(100);
                setTimeout(()=> {
                    setUploading(false);
                    setUploadProgress(0);
                    successCB(result.data);
                }, 200);
            }
        }
        catch (e) {
            console.error("Error uploading file", e);
            dialogueCloseHandler();
        }
    }

    const getFileRejectMessage = (rejectedFile, acceptedFiles, maxFileSize) => {
        const typeRegex = new RegExp(`(${acceptedFiles.join("|")})$`, "i")
        if(!typeRegex.test(rejectedFile.name))
            return "File {file_name} does not have allowed file type, i.e. {file_types}.".format({file_name: rejectedFile.name, file_types: acceptedFiles.join(', ')})
        if(rejectedFile.size === 0)
            return "File size cannot be 0";
        if(rejectedFile.size > maxFileSize)
            return `File size cannot be greater than {max_size} kb`.format({max_size: Math.ceil(maxFileSize/1000)});
        return "Invalid file";
    }

    return (
        <>
            <DropzoneDialog
                open={openDialogue}
                onSave={FileDialogueHandleSave}
                acceptedFiles={['.doc', '.docx', '.jpeg', '.jpg', '.png', '.pdf']}
                showPreviews={true}
                maxFileSize={5000000}
                filesLimit={1}
                onClose={dialogueCloseHandler}
                dropzoneProps={{minSize: 1}}
                getDropRejectMessage={getFileRejectMessage}
            />
            {
                <LoaderBackDropWithPercentage
                    loading={uploading}
                    value={uploadProgress}
                />
            }
        </>
    );
}

const RegistrationForm = () => {
    const classes = useStyles();
    const history = useHistory();
    const { setAuthToken, setAuthUser } = useAuth();
    const [loading, setLoading] = useState(false);
    const [activeStep, setActiveStep] = useState(0);
    const [country, setCountry] = useState("");
    const [referralCode, setReferralCode] = useState("");
    const [formSubmitted, setFormSubmitted] = useState(false);
    const [selectedType, setSelectedType] = useState("");
    const [individualData, setIndividualData] = useState({
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        address: "",
        city: "",
        country: "",
        postalCode: "",
        website: "",
        idFile: null,
    });
    const [businessData, setBusinessData] = useState({
        firstName: "",
        lastName: "",
        email: "",
        // phone: "",
        businessName: "",
        businessType: "",
        // registrationNumber: "",
        address: "",
        city: "",
        country: "",
        postalCode: "",
        website: "",
        registrationFile: null,
        registrationFileName: ""
    });
    const [backgroundExperience, setBackgroundExperience] = useState("");
    const [TargetAudience, setTargetAudience] = useState("");
    const [otherTargetAud, setOtherTargetAud] = useState("");
    const targetAudienceOptions = Object.values(PROGRAM_TARGETS);
    const [promotionMethods, setPromotionMethods] = useState("");
    const promotionMethodsOptions = Object.values(PROMOTION_METHODS);
    const [fileDialogOpen, setFileDialogOpen] = useState(false);
    const [fileUploadType, setFileUploadType] = useState("");
    const [registrationError, setRegistrationError] = useState(false);
    const [userExistsError, setUserExistsError] = useState(false);
    const [userExistsLoading, setUserExistsLoading] = useState(false);
    const [verificationDialogOpen, setVerificationDialogOpen] = useState(false);

    const handleOpenVerificationDialog = () => {
        setVerificationDialogOpen(true);
    };

    const handleCloseVerificationDialog = () => {
        setVerificationDialogOpen(false);
    };


    const handleNext = () => {
        if (activeStep === 1 && !selectedType) {
            alert("Please select an option.");
            return;
        }
        setActiveStep((prev) => prev + 1);
    };

    function parseInitialValues(initialValue, options) {
        return initialValue
            ? initialValue.split(', ').map(value => options.find(option => option.value === value)).filter(Boolean)
            : [];
    }

    const targetAudienceInitialValues = parseInitialValues(TargetAudience, targetAudienceOptions);
    const promotionMethodsInitialValues = parseInitialValues(promotionMethods, promotionMethodsOptions);

    const handleSignup = async (values) => {
        console.log('Form data => ', values);

        try {
            setLoading(true);
            setRegistrationError(false);
            const result = await registerUser(values);
            if (result.data && result.data.user) {
                // await setAuthToken(result.data.auth_token);
                // await setAuthUser(result.data.user);
                // localStorage.setItem(LOCAL_STORAGE_KEYS.refresh_token, JSON.stringify(result.data.refresh_token));
                // localStorage.setItem(LOCAL_STORAGE_KEYS.dq_insider_profile, JSON.stringify(result.data.dq_insider_profile));
                // history.push('/login');
                setLoading(false);
                return true;
            }
            setLoading(false);
            setRegistrationError(true);
            return false;
        } catch (e) {
            // already toasted the error
            setLoading(false);
            setRegistrationError(true);
            return false;
        }
    };

    const validateIndividualForm = () => {
        setFormSubmitted(true);

        const requiredFields = [
            "firstName",
            "lastName",
            "email",
            "phone",
            "address",
            "city",
            "country",
            "postalCode",
        ];

        return requiredFields.every(field => individualData[field]?.toString().trim() !== "")
            && !!individualData.idFileName;
    };


    const validateBusinessForm = () => {
        setFormSubmitted(true);

        const requiredFields = [
            "firstName",
            "lastName",
            "email",
            // "phone",
            "businessName",
            "businessType",
            // "registrationNumber",
            "address",
            "city",
            "country",
            "postalCode",
        ];

        return requiredFields.every(field => businessData[field]?.toString().trim() !== "")
            && !!businessData.registrationFileName;
    };


    const renderStepContent = () => {
        switch (activeStep) {
            case 0:
                return (
                    <>
                        <Typography variant="h4" style={{ fontWeight: 'bold',width:'80%', textAlign: 'center', color: '#ff5757' }}>
                        Let's Get Started
                        </Typography>
                        <Typography variant="h5" className={classes.question}>
                            What markets are you looking to reach?
                        </Typography>
                        <Typography variant="h6" className={classes.optional}>
                            If you're not sure, you can leave this blank.
                        </Typography>
                            <FormControl
                                fullWidth
                                variant="outlined"
                                className={classes.inputField}
                                style={{ backgroundColor: '#fff',width:'66%', borderRadius: '5px' }}
                            >
                                <Autocomplete
                                    className={classes.autoCompField}
                                    options={REGIONS}
                                    getOptionLabel={(option) => option.label}
                                    value={REGIONS.find(option => option.value === country) || null}
                                    onChange={(event, newValue) => {
                                        setCountry(newValue ? newValue.value : "");
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="Country"
                                            variant="outlined"
                                            InputLabelProps={{
                                                style: { color: '#929EA7' },
                                                sx: {
                                                    '&.Mui-focused': {
                                                        color: '#929EA7',
                                                    },
                                                }
                                            }}
                                        />
                                    )}
                                />
                            </FormControl>

                        <Typography variant="h5" className={classes.question} style={{ marginBottom: '6px' }}>
                            If you have a referral code, enter it here.
                        </Typography>
                        <Typography variant="h6" className={classes.optional}>
                            (optional)
                        </Typography>
                        <FormControl
                            fullWidth
                            variant="outlined"
                            className={classes.inputField}
                            style={{ backgroundColor: '#fff', borderRadius: '5px', }}
                        >
                        <TextField
                            label="Enter Code"
                            variant="outlined"
                            value={referralCode}
                            onChange={(e) => setReferralCode(e.target.value)}
                        />
                        </FormControl>
                    </>
                );
            case 1:
                return (
                    <>
                        <Typography variant="h4" className={classes.question}>
                            I am a(n):
                        </Typography>
                        <Box display="flex" justifyContent="center" gap={2}>
                            <Button
                                sx={{
                                    textTransform: 'none',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    color: selectedType === "individual" ? '#fff' : '#ff6468 !important',
                                    fontSize: '18px',
                                    py: 2,
                                    px: 3,
                                    minWidth: 140,
                                    backgroundColor: selectedType === "individual" ? '#ff6468' : 'transparent',
                                    '&:hover': {
                                        backgroundColor: '#ff6468',
                                        color: '#fff',
                                        '& .MuiSvgIcon-root': {
                                            color: '#fff !important'
                                        }
                                    },
                                    '& .MuiButton-startIcon': {
                                        margin: 0,
                                        display: 'flex',
                                        flexDirection: 'column'
                                    }
                                }}
                                className={`${classes.optionButton} ${selectedType === "individual" ? classes.selectedOption : ''}`}
                                variant={selectedType === "individual" ? "contained" : "outlined"}
                                onClick={() => setSelectedType("individual")}
                            >
                                <Box sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    marginTop:'-23px',
                                }}>
                                    <PersonIcon style={{
                                        color: selectedType === "individual" ? '#fff !important' : '#ff6468 !important',
                                        fontSize: '50px',
                                        marginBottom: '15px',
                                        transition: 'color 0.3s ease'
                                    }} />
                                    <span style={{ fontSize: '18px' }}>Individual</span>
                                </Box>
                            </Button>

                            {/* Business Button */}
                            <Button
                                sx={{
                                    textTransform: 'none',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    color: selectedType === "business" ? '#fff' : '#ff6468 !important',
                                    fontSize: '18px',
                                    py: 2,
                                    px: 3,
                                    minWidth: 140,
                                    '& .MuiButton-startIcon': {
                                        margin: 0,
                                        display: 'flex',
                                        flexDirection: 'column'
                                    },
                                    '&:hover': {
                                        backgroundColor: '#ff6468',
                                        color: '#fff',
                                        '& .MuiSvgIcon-root': {
                                            color: '#fff !important'
                                        }
                                    },
                                }}
                                className={`${classes.optionButton} ${selectedType === "business" ? classes.selectedOption : ''}`}
                                variant={selectedType === "business" ? "contained" : "outlined"}
                                onClick={() => setSelectedType("business")}
                            >
                                <Box sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center'
                                }}>
                                    <BusinessIcon style={{
                                        color: selectedType === "business" ? '#fff !important' : '#ff6468 !important',
                                        fontSize: '50px',
                                        marginBottom: '15px',
                                        transition: 'color 0.3s ease'
                                    }} />
                                    <Box sx={{
                                        fontSize: '18px',
                                        textAlign: 'center',
                                        lineHeight: 1.2
                                    }}>
                                        Registered <br /> Business
                                    </Box>
                                </Box>
                            </Button>
                        </Box>
                        {formSubmitted && !selectedType && (
                            <Typography color="error" align="center" style={{ marginTop: '10px' }}>
                                Please select an option to proceed
                            </Typography>
                        )}
                    </>
                );
            case 2:
                return selectedType === "individual" ? (
                    <>
                        <Typography variant="h4" style={{marginTop:'20px',fontWeight:'bold',color:'#000000', marginBottom:'20px'}}>
                            Your Information
                        </Typography>

                        <Grid container spacing={2} alignItems="center" style={{width:{xs:'100%', sm:"70%"}, margin: "0 auto"}}>
                            {/* Full Name */}
                            <Grid item xs={12} sm={6} style={{paddingBottom: 0}}>
                                <FormControl
                                    fullWidth
                                    variant="outlined"
                                    className={classes.inputField}
                                    style={{ backgroundColor: '#fff',width:"100%",marginBottom:'12px', borderRadius: '5px' }}
                                >
                                    <TextField
                                        label="First Name"
                                        variant="outlined"
                                        value={individualData.firstName}
                                        onChange={(e) => setIndividualData({ ...individualData, firstName: e.target.value })}
                                        error={formSubmitted && !individualData.firstName}
                                    />
                                    {!individualData.firstName && formSubmitted && (
                                        <FormHelperText error style={{ color: '#ff5757' }}>Please fill out this field.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>

                            <Grid item xs={12} sm={6} style={{paddingBottom: 0}}>
                                <FormControl
                                    fullWidth
                                    variant="outlined"
                                    className={classes.inputField}
                                    style={{ backgroundColor: '#fff',width:"100%",marginBottom:'12px', borderRadius: '5px' }}
                                >
                                    <TextField
                                        label="Last Name"
                                        variant="outlined"
                                        value={individualData.lastName}
                                        onChange={(e) => setIndividualData({ ...individualData, lastName: e.target.value })}
                                        error={formSubmitted && !individualData.lastName}
                                    />
                                    {!individualData.lastName && formSubmitted && (
                                        <FormHelperText error style={{ color: '#ff5757' }}>Please fill out this field.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>

                            {/* Email */}
                            <Grid item xs={12} style={{paddingTop: 0, paddingBottom: 0}}>
                                <FormControl
                                    fullWidth
                                    variant="outlined"
                                    className={classes.inputField}
                                    style={{ backgroundColor: '#fff',width:"100%",marginBottom:'12px', borderRadius: '5px' }}
                                >
                                    <TextField
                                        label="Email Address"
                                        variant="outlined"
                                        value={individualData.email}
                                        onChange={(e) => setIndividualData({ ...individualData, email: e.target.value })}
                                        error={formSubmitted && (!individualData.email || !/^\S+@\S+\.\S+$/.test(individualData.email))}
                                        helperText={
                                            formSubmitted && !individualData.email ? "Please fill out this field." :
                                                formSubmitted && !/^\S+@\S+\.\S+$/.test(individualData.email) ? "Invalid email" : ""
                                        }
                                    />
                                    {/*{userExistsError && (*/}
                                    {/*    <FormHelperText error style={{ color: '#ff5757', textAlign: 'center', marginBottom: 10 }}>*/}
                                    {/*        A user with this email already exists. Please use a different email.*/}
                                    {/*    </FormHelperText>*/}
                                    {/*)}*/}
                                </FormControl>
                            </Grid>

                            {/* Phone */}
                            <Grid item xs={12} style={{paddingTop: 0, paddingBottom: 0}}>
                                <FormControl
                                    fullWidth
                                    variant="outlined"
                                    className={classes.inputField}
                                    style={{ backgroundColor: '#fff',width:"100%",marginBottom:'12px', borderRadius: '5px' }}
                                >
                                    <TextField
                                        label="Phone Number"
                                        variant="outlined"
                                        type="number"
                                        value={individualData.phone}
                                        onChange={(e) => setIndividualData({ ...individualData, phone: e.target.value })}
                                        error={formSubmitted && !individualData.phone}
                                        helperText={formSubmitted && !individualData.phone ? "Please fill out this field." : ""}
                                    />
                                </FormControl>
                            </Grid>

                            {/* Address */}
                            <Grid item xs={12} style={{paddingTop: 0, paddingBottom: 0}}>
                                <FormControl
                                    fullWidth
                                    variant="outlined"
                                    className={classes.inputField}
                                    style={{ backgroundColor: '#fff',width:"100%",marginBottom:'12px', borderRadius: '5px' }}
                                >
                                    <TextField
                                        label="Address"
                                        variant="outlined"
                                        value={individualData.address}
                                        onChange={(e) => setIndividualData({ ...individualData, address: e.target.value })}
                                        error={formSubmitted && !individualData.address}
                                        helperText={formSubmitted && !individualData.address ? "Please fill out this field." : ""}
                                    />
                                </FormControl>
                            </Grid>

                            {/* City */}
                            <Grid item xs={12} style={{paddingTop: 0, paddingBottom: 0}}>
                                <FormControl
                                    fullWidth
                                    variant="outlined"
                                    className={classes.inputField}
                                    style={{ backgroundColor: '#fff',width:"100%",marginBottom:'12px', borderRadius: '5px' }}
                                >
                                    <TextField
                                        label="City"
                                        variant="outlined"
                                        value={individualData.city}
                                        onChange={(e) => setIndividualData({ ...individualData, city: e.target.value })}
                                        error={formSubmitted && !individualData.city}
                                        helperText={formSubmitted && !individualData.city ? "Please fill out this field." : ""}
                                    />
                                </FormControl>
                            </Grid>

                            {/* Country */}
                            <Grid item xs={12} style={{paddingTop: 0, paddingBottom: 0}}>
                                <FormControl
                                    fullWidth
                                    variant="outlined"
                                    className={classes.inputField}
                                    style={{ backgroundColor: '#fff',width:"100%",marginBottom:'12px', borderRadius: '5px' }}
                                >
                                    <Autocomplete
                                        className={classes.autoCompField}
                                        options={REGIONS}
                                        getOptionLabel={(option) => option.label}
                                        value={REGIONS.find(option => option.value === individualData.country) || null}
                                        onChange={(event, newValue) => {
                                            setIndividualData({
                                                ...individualData,
                                                country: newValue ? newValue.value : ""
                                            });
                                        }}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label="Country"
                                                variant="outlined"
                                                error={formSubmitted && !individualData.country}
                                                helperText={
                                                    formSubmitted && !individualData.country
                                                        ? "Please fill out this field."
                                                        : ""
                                                }
                                                InputLabelProps={{
                                                    style: { color: '#929EA7' },
                                                    sx: {
                                                        '&.Mui-focused': {
                                                            color: '#929EA7',
                                                        },
                                                    }
                                                }}
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Grid>

                            {/* Postal Code */}
                            <Grid item xs={12} style={{paddingTop: 0, paddingBottom: 0}}>
                                <FormControl
                                    fullWidth
                                    variant="outlined"
                                    className={classes.inputField}
                                    style={{ backgroundColor: '#fff',width:"100%",marginBottom:'12px', borderRadius: '5px' }}
                                >
                                    <TextField
                                        label="Postal Code"
                                        variant="outlined"
                                        value={individualData.postalCode}
                                        onChange={(e) => setIndividualData({ ...individualData, postalCode: e.target.value })}
                                        error={formSubmitted && !individualData.postalCode}
                                        helperText={formSubmitted && !individualData.postalCode ? "Please fill out this field." : ""}
                                    />
                                </FormControl>
                            </Grid>

                            {/* Website */}
                            <Grid item xs={12} style={{paddingTop: 0, paddingBottom: 0}}>
                                <FormControl
                                    fullWidth
                                    variant="outlined"
                                    className={classes.inputField}
                                    style={{ backgroundColor: '#fff',width:"100%",marginBottom:'12px', borderRadius: '5px' }}
                                >
                                    <TextField
                                        label="Website (optional)"
                                        variant="outlined"
                                        value={individualData.website}
                                        onChange={(e) => setIndividualData({ ...individualData, website: e.target.value })}
                                    />
                                </FormControl>
                            </Grid>

                            {/* Upload ID */}
                            <Grid item xs={12} style={{paddingTop: 0, paddingBottom: 0}}>
                                <Typography gutterBottom align="center" style={{ marginBottom: 16, fontSize:'19px' }}>
                                    Upload a valid copy of your ID. (Driver's licenses, ID, or passport are accepted.) <br />
                                    <Typography
                                        onClick={handleOpenVerificationDialog}
                                        style={{
                                            textDecoration: 'underline',
                                            cursor:'pointer',
                                            fontWeight: 'bold',
                                            padding: 0,
                                            textTransform: 'none',
                                            minWidth: 'auto',
                                            backgroundColor:'transparent'
                                        }}
                                    >
                                        Why do we need this?
                                    </Typography>
                                </Typography>

                                <VerificationDialog
                                    open={verificationDialogOpen}
                                    onClose={handleCloseVerificationDialog}
                                />

                                {individualData.idFileName && (
                                    <div style={{ border:'1px solid #ff5757', borderRadius:'7px', padding:'7px',width:'fit-content',display: 'flex', alignItems: 'center', margin: '0 auto 16px auto' }}>
                                        <Typography variant="body2" style={{ color: '#ff5757', marginRight: 8 }}>
                                            {individualData.idFileName}
                                        </Typography>
                                        <IconButton
                                            size="small"
                                            onClick={() =>
                                                setIndividualData({
                                                    ...individualData,
                                                    idFileName: "",
                                                })
                                            }
                                        >
                                            <CloseIcon fontSize="small" />
                                        </IconButton>
                                    </div>
                                )}

                                <Box display="flex" justifyContent="center">
                                    <Button
                                        variant="outlined"
                                        component="label"
                                        style={{backgroundColor:'#000000',fontSize:'18px',fontWeight:'bold',color:'#ffffff',padding:'10px 24px'}}
                                        onClick={() => {
                                            setFileUploadType("individual");
                                            setFileDialogOpen(true);
                                        }}
                                    >
                                        Upload File
                                    </Button>
                                </Box>

                                {formSubmitted && !individualData.idFileName && (
                                    <Typography variant="body2" color="error" align="center" style={{ marginTop: 8 }}>
                                        Please upload your ID
                                    </Typography>
                                )}
                            </Grid>
                        </Grid>
                    </>
                ) : (
                    <>

                        <Typography variant="h4" style={{marginTop:'20px',fontWeight:'bold',color:'#000000', marginBottom:'20px'}}>
                            Your Business Information
                        </Typography>

                        <Grid container spacing={2} alignItems="center" sx={{width:{xs:'100%', sm:"70%"}}}>
                            {/* Full Name */}
                            <Grid item xs={12} sm={6} style={{paddingBottom: 0}}>
                                <FormControl
                                    fullWidth
                                    variant="outlined"
                                    className={classes.inputField}
                                    style={{ backgroundColor: '#fff',width:"100%",marginBottom:'12px', borderRadius: '5px' }}
                                >
                                    <TextField
                                        label="First Name"
                                        variant="outlined"
                                        value={businessData.firstName}
                                        onChange={(e) => setBusinessData({ ...businessData, firstName: e.target.value })}
                                        error={formSubmitted && !businessData.firstName}
                                        helperText={formSubmitted && !businessData.firstName ? "Please fill out this field." : ""}
                                    />
                                </FormControl>
                            </Grid>

                            <Grid item xs={12} sm={6} style={{paddingBottom: 0}}>
                            <FormControl
                                    fullWidth
                                    variant="outlined"
                                    className={classes.inputField}
                                    style={{ backgroundColor: '#fff',width:"100%",marginBottom:'12px', borderRadius: '5px' }}
                                >
                                    <TextField
                                        label="Last Name"
                                        variant="outlined"
                                        value={businessData.lastName}
                                        onChange={(e) => setBusinessData({ ...businessData, lastName: e.target.value })}
                                        error={formSubmitted && !businessData.lastName}
                                        helperText={formSubmitted && !businessData.lastName ? "Please fill out this field." : ""}
                                    />
                                </FormControl>
                            </Grid>

                            {/* Email */}
                            <Grid item xs={12} style={{paddingTop: 0, paddingBottom: 0}}>
                            <FormControl
                                    fullWidth
                                    variant="outlined"
                                    className={classes.inputField}
                                    style={{ backgroundColor: '#fff',width:"100%",marginBottom:'12px', borderRadius: '5px' }}
                                >
                                    <TextField
                                        label="Email Address"
                                        variant="outlined"
                                        InputLabelProps={{ style: { textAlign: 'center' } }}
                                        value={businessData.email}
                                        onChange={(e) => setBusinessData({ ...businessData, email: e.target.value })}
                                        error={formSubmitted && (!businessData.email || !/^\S+@\S+\.\S+$/.test(businessData.email))}
                                        helperText={
                                            formSubmitted && !businessData.email ? "Please fill out this field." :
                                                formSubmitted && !/^\S+@\S+\.\S+$/.test(businessData.email) ? "Invalid email" : ""
                                        }
                                    />
                                {/*{userExistsError && (*/}
                                {/*    <FormHelperText error style={{ color: '#ff5757', textAlign: 'center', marginBottom: 10 }}>*/}
                                {/*        A user with this email already exists. Please use a different email.*/}
                                {/*    </FormHelperText>*/}
                                {/*)}*/}
                            </FormControl>
                            </Grid>

                            {/* Business Name */}
                            <Grid item xs={12} style={{paddingTop: 0, paddingBottom: 0}}>
                            <FormControl
                                    fullWidth
                                    variant="outlined"
                                    className={classes.inputField}
                                    style={{ backgroundColor: '#fff',width:"100%",marginBottom:'12px', borderRadius: '5px' }}
                                >
                                    <TextField
                                        label="Business Name"
                                        variant="outlined"
                                        InputLabelProps={{ style: { textAlign: 'center' } }}
                                        value={businessData.businessName}
                                        onChange={(e) => setBusinessData({ ...businessData, businessName: e.target.value })}
                                        error={formSubmitted && !businessData.businessName}
                                        helperText={formSubmitted && !businessData.businessName ? "Please fill out this field." : ""}
                                    />
                                </FormControl>
                            </Grid>

                            {/* Business Type */}
                            <Grid item xs={12} style={{paddingTop: 0, paddingBottom: 0}}>
                            <FormControl
                                    fullWidth
                                    variant="outlined"
                                    className={classes.inputField}
                                    style={{ backgroundColor: '#fff',width:"100%",marginBottom:'12px', borderRadius: '5px' }}
                                >
                                <Autocomplete
                                    className={classes.autoCompField}
                                    options={ORG_TYPES}
                                    getOptionLabel={(option) => option.label}
                                    value={ORG_TYPES.find(option => option.value === businessData.businessType) || null}
                                    onChange={(event, newValue) => {
                                        setBusinessData({
                                            ...businessData,
                                            businessType: newValue ? newValue.value : ""
                                        });
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="Business Type"
                                            variant="outlined"
                                            InputLabelProps={{ style: { textAlign: 'center' } }}
                                            error={formSubmitted && !businessData.businessType}
                                            helperText={
                                                formSubmitted && !businessData.businessType
                                                    ? "Please fill out this field."
                                                    : ""
                                            }
                                        />
                                    )}
                                />
                                </FormControl>
                            </Grid>

                            {/* Address */}
                            <Grid item xs={12} style={{paddingTop: 0, paddingBottom: 0}}>
                            <FormControl
                                    fullWidth
                                    variant="outlined"
                                    className={classes.inputField}
                                    style={{ backgroundColor: '#fff',width:"100%",marginBottom:'12px', borderRadius: '5px' }}
                                >
                                    <TextField
                                        label="Business Address"
                                        variant="outlined"
                                        InputLabelProps={{ style: { textAlign: 'center' } }}
                                        value={businessData.address}
                                        onChange={(e) => setBusinessData({ ...businessData, address: e.target.value })}
                                        error={formSubmitted && !businessData.address}
                                        helperText={formSubmitted && !businessData.address ? "Please fill out this field." : ""}
                                    />
                                </FormControl>
                            </Grid>

                            {/* City */}
                            <Grid item xs={12} style={{paddingTop: 0, paddingBottom: 0}}>
                                <FormControl
                                    fullWidth
                                    variant="outlined"
                                    className={classes.inputField}
                                    style={{ backgroundColor: '#fff',width:"100%",marginBottom:'12px', borderRadius: '5px' }}
                                >
                                    <TextField
                                        label="City"
                                        variant="outlined"
                                        InputLabelProps={{ style: { textAlign: 'center' } }}
                                        value={businessData.city}
                                        onChange={(e) => setBusinessData({ ...businessData, city: e.target.value })}
                                        error={formSubmitted && !businessData.city}
                                        helperText={formSubmitted && !businessData.city ? "Please fill out this field." : ""}
                                    />
                                </FormControl>
                            </Grid>

                            {/* Country */}
                            <Grid item xs={12} style={{paddingTop: 0, paddingBottom: 0}}>
                                <FormControl
                                    fullWidth
                                    variant="outlined"
                                    className={classes.inputField}
                                    style={{ backgroundColor: '#fff',width:"100%",marginBottom:'12px', borderRadius: '5px' }}
                                >
                                    <Autocomplete
                                        className={classes.autoCompField}
                                        options={REGIONS}
                                        getOptionLabel={(option) => option.label}
                                        value={REGIONS.find(option => option.value === businessData.country) || null}
                                        onChange={(event, newValue) => {
                                            setBusinessData({
                                                ...businessData,
                                                country: newValue ? newValue.value : ""
                                            });
                                        }}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label="Country"
                                                variant="outlined"
                                                InputLabelProps={{ style: { textAlign: 'center' } }}
                                                error={formSubmitted && !businessData.country}
                                                helperText={
                                                    formSubmitted && !businessData.country
                                                        ? "Please fill out this field."
                                                        : ""
                                                }
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Grid>

                            {/* Postal Code */}
                            <Grid item xs={12} style={{paddingTop: 0, paddingBottom: 0}}>
                                <FormControl
                                    fullWidth
                                    variant="outlined"
                                    className={classes.inputField}
                                    style={{ backgroundColor: '#fff',width:"100%",marginBottom:'12px', borderRadius: '5px' }}
                                >
                                    <TextField
                                        label="Postal Code"
                                        variant="outlined"
                                        InputLabelProps={{ style: { textAlign: 'center' } }}
                                        value={businessData.postalCode}
                                        onChange={(e) => setBusinessData({ ...businessData, postalCode: e.target.value })}
                                        error={formSubmitted && !businessData.postalCode}
                                        helperText={formSubmitted && !businessData.postalCode ? "Please fill out this field." : ""}
                                    />
                                </FormControl>
                            </Grid>

                            {/* Website */}
                            <Grid item xs={12} style={{paddingTop: 0, paddingBottom: 0}}>
                                <FormControl
                                    fullWidth
                                    variant="outlined"
                                    className={classes.inputField}
                                    style={{ backgroundColor: '#fff',width:"100%",marginBottom:'12px', borderRadius: '5px' }}
                                >
                                    <TextField
                                        label="Business Website (optional)"
                                        variant="outlined"
                                        InputLabelProps={{ style: { textAlign: 'center' } }}
                                        value={businessData.website}
                                        onChange={(e) => setBusinessData({ ...businessData, website: e.target.value })}
                                    />
                                </FormControl>
                            </Grid>

                            {/* Upload Registration File */}
                            <Grid item xs={12} style={{paddingTop: 0, paddingBottom: 0}}>
                                <Typography gutterBottom align="center" style={{ marginBottom: 16, fontSize:'19px' }}>
                                    Upload a valid copy of your business registration or incorporation.<br />
                                    <Typography
                                        onClick={handleOpenVerificationDialog}
                                        style={{
                                            textDecoration: 'underline',
                                            cursor:'pointer',
                                            fontWeight: 'bold',
                                            padding: 0,
                                            textTransform: 'none',
                                            minWidth: 'auto',
                                            backgroundColor:'transparent'
                                        }}
                                    >
                                        Why do we need this?
                                    </Typography>
                                </Typography>

                                <VerificationDialog
                                    open={verificationDialogOpen}
                                    onClose={handleCloseVerificationDialog}
                                />

                                {businessData.registrationFileName && (
                                    <div style={{ margin: '0 auto 16px auto',border:'1px solid #ff5757', borderRadius:'7px', padding:'7px',width:'fit-content',display: 'flex', alignItems: 'center', marginBottom: 8 }}>
                                        <Typography variant="body2" style={{ color: '#ff5757', marginRight: 8 }}>
                                            {businessData.registrationFileName}
                                        </Typography>
                                        <IconButton
                                            size="small"
                                            onClick={() =>
                                                setBusinessData({
                                                    ...businessData,
                                                    registrationFileName: "",
                                                })
                                            }
                                        >
                                            <CloseIcon fontSize="small" />
                                        </IconButton>
                                    </div>
                                )}

                                <Box display="flex" justifyContent="center">
                                    <Button
                                        variant="outlined"
                                        component="label"
                                        style={{
                                            backgroundColor: '#000000',
                                            fontSize: '18px',
                                            fontWeight: 'bold',
                                            color: '#ffffff',
                                            padding: '10px 24px',
                                        }}
                                        onClick={() => {
                                            setFileUploadType("business");
                                            setFileDialogOpen(true);
                                        }}
                                    >
                                        Upload File
                                    </Button>
                                </Box>

                                {formSubmitted && !businessData.registrationFileName && (
                                    <Typography variant="body2" color="error" align="center" style={{ marginTop: 8 }}>
                                        Please upload registration document
                                    </Typography>
                                )}
                            </Grid>
                        </Grid>
                    </>

                );
            case 3:
                return (
                    <>
                        <Typography variant="h4" className={classes.question}>
                            Your Background and Experience
                        </Typography>
                        <Typography className={classes.subText}>
                            Briefly describe your experience in education, AI/digital literacy, or community outreach. This will help us understand who you are, what you’re all about, and increases your chances
                            of joining Powered by DQ.
                        </Typography>
                        <TextField
                            multiline
                            rows={6}
                            fullWidth
                            variant="outlined"
                            className={classes.textAreaField}
                            value={backgroundExperience}
                            onChange={(e) => setBackgroundExperience(e.target.value)}
                            error={!backgroundExperience && formSubmitted}
                            style={{ backgroundColor: '#fff',width:'100%', borderRadius: '5px' }}
                        />
                        {!backgroundExperience && formSubmitted && (
                            <FormHelperText error style={{ color: '#ff5757' }}>Please enter your background experience</FormHelperText>
                        )}
                    </>
                );
            case 4:
                return (
                    <Box display="flex" flexDirection="column" width='78%' alignItems="center">
                        <Box width="100%">
                        <Typography variant="h5" className={classes.question}>
                            Who's your target audience?
                        </Typography>
                        <Typography variant="h6" className={classes.optional} style={{textAlign:"center"}}>
                            (You can select more than one.)
                        </Typography>
                            <FormControl
                                fullWidth
                                variant="outlined"
                                className={classes.inputField}
                                style={{ backgroundColor: '#fff', width: '100%', borderRadius: '5px' }}
                            >
                                <Autocomplete
                                    className={classes.autoCompField}
                                    multiple
                                    fullWidth
                                    required
                                    options={Object.values(PROGRAM_TARGETS)}
                                    getOptionLabel={(option) => option.label}
                                    value={targetAudienceInitialValues}
                                    onChange={(event, newValue) => {
                                        setTargetAudience(newValue.map(item => item.value).join(', '));
                                    }}
                                    disableCloseOnSelect
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            variant="outlined"
                                            label="Select Target Audience"
                                            className={classes.formField}
                                            error={formSubmitted && TargetAudience.length === 0}
                                            helperText={
                                                formSubmitted && TargetAudience.length === 0
                                                    ? 'Please select at least one target audience'
                                                    : ''
                                            }
                                        />
                                    )}
                                />

                            </FormControl>
                            <Grid item xs={12} style={{paddingTop: 0, paddingBottom: 0}}>
                                <FormControl
                                    fullWidth
                                    variant="outlined"
                                    className={classes.inputField}
                                    style={{ backgroundColor: '#fff',width:"100%", borderRadius: '5px' }}
                                >
                            {TargetAudience && (TargetAudience.includes('Others') ||
                                (targetAudienceInitialValues.some(item => item.value === 'Others'))) ? (
                                <TextField
                                    label="Please specify target audience."
                                    variant="outlined"
                                    name="otherTargetAud"
                                    onChange={(e) => setOtherTargetAud(e.target.value)}
                                />
                            ) : null}
                            </FormControl>
                            </Grid>
                        <Typography variant="h5" className={classes.question}  sx={{ marginTop:{xs:'0px',sm:'50px'} }}>
                            How do you plan to promote?
                        </Typography>
                        <Typography variant="h6" className={classes.optional} style={{textAlign:"center"}}>
                            (You can select more than one.)
                        </Typography>
                            <FormControl
                                fullWidth
                                variant="outlined"
                                className={classes.inputField}
                                style={{ backgroundColor: '#fff',width:'100%', borderRadius: '5px' }}
                            >
                        <Autocomplete
                            className={classes.autoCompField}
                            multiple
                            fullWidth
                            required
                            options={Object.values(PROMOTION_METHODS)}
                            getOptionLabel={(option) => option.label}
                            value={promotionMethodsInitialValues}
                            onChange={(event, newValue) => {
                                setPromotionMethods(newValue.map(item => item.value).join(', '));
                            }}
                            disableCloseOnSelect
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    variant="outlined"
                                    label="Select Promotion Methods"
                                    className={classes.formField}
                                    error={formSubmitted && promotionMethods.length === 0}
                                    helperText={
                                        formSubmitted && promotionMethods.length === 0
                                            ? 'Please select at least one promotion method'
                                            : ''
                                    }
                                />
                            )}
                        />
                            </FormControl>
                        </Box>
                    </Box>
                );
            case 5:
                return(
                    <Box display="flex" flexDirection="column" width='100%' alignItems="center">
                        <TermOfUse
                            setActiveStep={setActiveStep}
                            standalone = {false}
                            onAgree={async () => {
                                setLoading(true);
                                setRegistrationError(false);
                                const success = await handleSignup({
                                    email: selectedType === 'individual' ? individualData.email : businessData.email,
                                    country:  selectedType === 'individual' ? individualData.country : businessData.country,
                                    targetCountry: country,
                                    referralCode,
                                    selectedType,
                                    individualData,
                                    businessData,
                                    backgroundExperience,
                                    targetAudience: targetAudienceInitialValues.map(item => item.value).join(', '),
                                    promotionMethods: promotionMethodsInitialValues.map(item => item.value).join(', '),
                                    individualFileId: individualData.idFileId,
                                    businessFileId: businessData.registrationFileId,
                                });
                                setLoading(false);
                                if (success) {
                                    setActiveStep(prev => prev + 1);
                                } else {
                                    setRegistrationError(true);
                                }
                            }}
                        />
                    </Box>
                )
            case 6:
                return (
                    <Box sx={{ width: '100%', maxWidth: 800, mx: 'auto', textAlign: 'center' }}>
                        <Typography variant="h3" className={classes.question} gutterBottom>
                            Thank You
                        </Typography>
                        {registrationError && (
                            <>
                                <Typography variant="h5" color="error" sx={{ mb: 2 }}>
                                    There was an error during registration. Please review your details and try again.
                                </Typography>
                            </>
                        )}
                        {!registrationError && (
                            <>
                                <Typography variant="h5" className={classes.optional}>
                                    Your application is under review.
                                </Typography>

                                <Typography variant="h5" className={classes.optional} style={{marginBottom: '2rem'}}>
                                    We will come back to you within 7 business days.
                                </Typography>

                                <Typography variant="h5" className={classes.optional}>
                                    If approved, we will send you an email to activate your Powered by DQ account and
                                    access your dedicated sales portal.
                                </Typography>
                            </>
                        )}

                    </Box>
                );
            default:
                return null;
        }
    };

    return (
        <Container sx={{
            position: 'relative',
            width: '100%',
            maxWidth: '1000px',
            margin: '0 auto',
        }}>
            <div className={classes.logoContainer}>
                <img
                    src={PoweredbyDQ}
                    alt="Logo"
                    className={classes.logo}
                />
            </div>
        <Box className={classes.container}>
            <CssBaseline />
            <LoaderWithBackDrop loading={loading} />

            <Typography variant="title" textAlign="center" gutterBottom className={classes.title}>
                Powered by DQ Application
            </Typography>

            <Box sx={{ p: {xs:0,sm:3} }}>
                <Stepper activeStep={activeStep} alternativeLabel className={classes.stepper}>
                    {steps.map((_, index) => (
                            <Step key={index}>
                                <StepLabel
                                    StepIconProps={{
                                        classes: {
                                            root: classes.stepIcon,
                                        }
                                    }}
                                />
                            </Step>
                    ))}
                </Stepper>
            </Box>

            {renderStepContent()}

            <Box sx={{display: 'flex', justifyContent: activeStep === 5 || activeStep === 6 || activeStep === 0 ? 'center' : 'center',  width: '100%', maxWidth: 800, mt: 9 }}>
                {(activeStep > 0 && activeStep < 6) || (activeStep === 6 && registrationError) ? (
                    <Button
                        variant="contained"
                        className={classes.backButton}
                        onClick={() => setActiveStep(prev => prev - 1)}
                        style={{
                            visibility: (activeStep === 5 && !registrationError) ? 'hidden' : 'visible',
                            marginRight:'30px'
                        }}
                    >
                        Back
                    </Button>
                ) : null}

                {activeStep !== 5 && (
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={async () => {
                            if (activeStep === 1) {
                                setFormSubmitted(true);
                                if (!selectedType) return;
                            }
                            if (activeStep === 2) {
                                const isValid = selectedType === "individual"
                                    ? validateIndividualForm()
                                    : validateBusinessForm();
                                if (!isValid) return;
                                setUserExistsError(false);

                                const email = selectedType === "individual"
                                    ? individualData.email
                                    : businessData.email;

                                setUserExistsLoading(true);
                                try {
                                    const response = await userExists(email);
                                    setUserExistsLoading(false);
                                    if (!response.data.success) {
                                        setUserExistsError(true);
                                        return;
                                    }
                                } catch (e) {
                                    setUserExistsLoading(false);
                                    setUserExistsError(true);
                                    return;
                                }
                            }
                            if (activeStep === 3) {
                                setFormSubmitted(true);
                                if (!backgroundExperience) return;
                            }
                            if (activeStep === 4) {
                                setFormSubmitted(true);
                                if (
                                    promotionMethodsInitialValues.length === 0 ||
                                    targetAudienceInitialValues.length === 0
                                ) return;
                            }

                            if (activeStep === 6) {
                                // const success = await handleSignup({
                                //     email: selectedType === 'individual' ? individualData.email : businessData.email,
                                //     country:  selectedType === 'individual' ? individualData.country : businessData.country,
                                //     targetCountry: country,
                                //     referralCode,
                                //     selectedType,
                                //     individualData,
                                //     businessData,
                                //     backgroundExperience,
                                //     targetAudience: targetAudienceInitialValues.map(item => item.value).join(', '),
                                //     promotionMethods: promotionMethodsInitialValues.map(item => item.value).join(', '),
                                //     individualFileId: individualData.idFileId,
                                //     businessFileId: businessData.registrationFileId,
                                // });
                                // if(success) {
                                    history.push("/login");
                                // }
                            } else {
                                setFormSubmitted(false);
                                setActiveStep(prev => prev + 1);
                            }
                        }}
                        className={classes.nextButton}
                        sx={{display: activeStep === 5 ? 'none' : 'visible'}}
                    >
                        {userExistsLoading ? "Checking..." : (activeStep === 6 ? "Done" : "Next")}
                    </Button>
                )}
            </Box>
        </Box>
        <UploadFileDialogue
            openDialogue={fileDialogOpen}
            dialogueCloseHandler={() => setFileDialogOpen(false)}
            successCB={(mediaData) => {
                const { media_path, file_id } = mediaData;
                if (fileUploadType === "individual") {
                    setIndividualData((prev) => ({
                        ...prev,
                        idFile: media_path,
                        idFileId: file_id,
                        idFileName: media_path.split('/').pop(), // just the file name
                    }));
                } else if (fileUploadType === "business") {
                    setBusinessData((prev) => ({
                        ...prev,
                        registrationFile: media_path,
                        registrationFileId: file_id,
                        registrationFileName: media_path.split('/').pop(),
                    }));
                }
                setFileDialogOpen(false);
            }}
        />
        </Container>
    );
};

export default withRouter(RegistrationForm);
